import { Global } from '@emotion/react';
import gilroyBoldUrl from '../assets/fonts/Gilroy-Bold.ttf';
import gilroySemiBoldUrl from '../assets/fonts/Gilroy-SemiBold.ttf';
import gilroyMediumUrl from '../assets/fonts/Gilroy-Medium.ttf';
import gilroyRegularUrl from '../assets/fonts/Gilroy-Regular.ttf';
import interBoldUrl from '../assets/fonts/Inter-Bold.otf';
import interSemiBoldUrl from '../assets/fonts/Inter-SemiBold.otf';
import interMediumUrl from '../assets/fonts/Inter-Medium.otf';
import interRegularUrl from '../assets/fonts/Inter-Regular.otf';
import openSansRegularUrl from '../assets/fonts/OpenSans-Regular.otf';
import openSansSemiBoldUrl from '../assets/fonts/OpenSans-SemiBold.otf';
import sfProDisplayRegularUrl from '../assets/fonts/SfProDisplay-Regular.otf';
import sfProDisplayMediumUrl from '../assets/fonts/SfProDisplay-Medium.otf';
import googleSansRegularUrl from '../assets/fonts/GoogleSans-Regular.ttf';
import googleSansMediumUrl from '../assets/fonts/GoogleSans-Medium.ttf';
import googleSansSemiBoldUrl from '../assets/fonts/GoogleSans-SemiBold.ttf';
import googleSansBoldUrl from '../assets/fonts/GoogleSans-Bold.ttf';

const Fonts = () => (
  <Global
    styles={`
      /* Gilroy */
      @font-face {
        font-family: 'Gilroy Bold';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
				src: local(''), url(${gilroyBoldUrl}) format('opentype');
      }
      @font-face {
        font-family: 'Gilroy SemiBold';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
				src: local(''), url(${gilroySemiBoldUrl}) format('opentype');
      }
      @font-face {
        font-family: 'Gilroy Medium';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
				src: local(''), url(${gilroyMediumUrl}) format('opentype');
      }
      @font-face {
        font-family: 'Gilroy Regular';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
				src: local(''), url(${gilroyRegularUrl}) format('opentype');
      }

      /* Inter */
      /* latin */
      @font-face {
        font-family: 'Inter Bold';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
				src: local(''), url(${interBoldUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Inter SemiBold';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
				src: local(''), url(${interSemiBoldUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Inter Medium';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
				src: local(''), url(${interMediumUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Inter Regular';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
				src: local(''), url(${interRegularUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Open Sans Regular';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
				src: local(''), url(${openSansRegularUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Open Sans SemiBold';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
				src: local(''), url(${openSansSemiBoldUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Sf Pro Display Regular';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
				src: local(''), url(${sfProDisplayRegularUrl}) format('opentype');
      }
      /* latin */
      @font-face {
        font-family: 'Sf Pro Display Medium';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
				src: local(''), url(${sfProDisplayMediumUrl}) format('opentype');
      }
      /* Google Sans */
      @font-face {
        font-family: 'Google Sans';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
				src: local(''), url(${googleSansRegularUrl}) format('truetype');
      }
      @font-face {
        font-family: 'Google Sans';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
				src: local(''), url(${googleSansMediumUrl}) format('truetype');
      }
      @font-face {
        font-family: 'Google Sans';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
				src: local(''), url(${googleSansSemiBoldUrl}) format('truetype');
      }
      @font-face {
        font-family: 'Google Sans';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
				src: local(''), url(${googleSansBoldUrl}) format('truetype');
      }
      `}
  />
);

export default Fonts;
